import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  TextField,
  useTheme,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { SubmitButton } from 'components';
import { ROUTES } from 'consts';

import { useAuthResetPasswordFormManager } from './auth-reset-password-form.hook';

interface AuthResetPasswordFormProps {
  token: string;
  email: string;
  next?: (data?: any) => void;
}

export const AuthResetPasswordForm = ({ token, email, next }: AuthResetPasswordFormProps) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const theme = useTheme();
  const [{ formManager, loading_submit }] = useAuthResetPasswordFormManager({ token, email, next });

  return (
    <form onSubmit={formManager.handleSubmit}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>New Password</InputLabel>
            <OutlinedInput
              type={showPassword ? 'text' : 'password'}
              onChange={formManager.handleChange('password')}
              endAdornment={
                <InputAdornment position="end" sx={{ marginRight: 1 }}>
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={(event) => event.preventDefault()}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff sx={{ color: theme.palette.text.secondary }} />
                    ) : (
                      <Visibility sx={{ color: theme.palette.text.secondary }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              label="New Password"
              error={!!(formManager.errors.password && formManager.touched.password)}
            />
            <FormHelperText error={!!(formManager.errors.password && formManager.touched.password)}>
              {formManager.touched.password ? formManager.errors.password : null}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Password Confirm"
            type="password"
            variant="outlined"
            fullWidth
            onChange={formManager.handleChange('passwordConfirm')}
            error={!!(formManager.errors.passwordConfirm && formManager.touched.passwordConfirm)}
            helperText={formManager.touched.passwordConfirm ? formManager.errors.passwordConfirm : null}
          />
        </Grid>

        <Grid item xs={12}>
          <SubmitButton loading={loading_submit} label={'Reset Password'} type="submit" sx={{ marginTop: 4 }} />
        </Grid>

        <Grid item xs={12}>
          <Link
            variant="subtitle2"
            onClick={() => navigate(`/${ROUTES.AUTH}/${ROUTES.AUTH_LOGIN}`)}
            sx={{ textDecoration: 'none', marginTop: 3, cursor: 'pointer', display: 'inline-flex' }}
          >
            Back to Login
          </Link>
        </Grid>
      </Grid>
    </form>
  );
};
